// extracted by css-extract-rspack-plugin
export default {"Octicon":"ActorAvatar-module__Octicon__KyPvm"};